import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
//import InputText from '../../elements/InputText';
import ButtonGroupSelection from '../../elements/ButtonGroupSelection';
import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import initTreeView from '../../../services/initTreeView';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { TabView, TabPanel } from 'primereact/tabview';
import { Badge } from 'primereact/badge';
import AddressFormModal from '../../modals/AddressFormModal';
 
export default function VendorForm (){
    const { vendor_id } = useParams();
    const [loading, setLoading] = useState(0);
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('New Vendor');
    const [record_data, setRecordData] = useState(store.vendor_data);
    const [address_list, setAddress] = useState([]);
    const [show_modal, setShowModal] = useState(0);
    const [selected_address_data, setAddressData] = useState('');
    const [selected_address_id, setAddressID] = useState('');
    const [selected_address_index, setAddressIndex] = useState('');
    const [table_items, setTableItems] = useState([]);
    
   
    useEffect(() => {
        initTreeView()

        if(vendor_id){
            setPageTitle('Vendor Details')
            fetchData(vendor_id)
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [address_list]);

    function fetchData(vendor_id){
        if(!vendor_id){
            return
        }
        const url = helpers.createUrl(`V1/manage/vendor/${vendor_id}?store_id=${helpers.getStoreID()}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setLoading(0)
            setRecordData(res)
            setAddress(res.address)
        })
        .catch((err) => {
            setLoading(0)
            //getEnums()

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/vendors/list");
                }
            })
        }); 
    }

    function displayTableItems(){
        let items = []
        
        if (address_list.length) {
            items = Object.entries(address_list).map(([key, data]) => {

                return(
                <tr>
                    <td>{helpers.filterObject(store.contact_address_type, data.address_type_id)?.label ?? '---'}</td>
                    <td>{data.address}</td>
                    <td>{data.contact_name}</td>
                    <td>{data.email ? data.email : '---'}</td>
                    <td>{data.phone_no ? data.phone_no : '---'}</td>
                    <td className='text-right'>
                        <button className='btn btn-primary btn-sm' type="button" onClick={(e) => editAddress(data, data.id, key)}><i className="fas fa-pencil-alt"></i></button>
                        <button className='btn btn-danger btn-sm ml-0 ml-sm-2 mt-2 mt-sm-0' type="button" onClick={(e) => removeItem(key)}><i className="fas fa-trash-alt"></i></button>
                    </td>
                </tr>)

            })
        }
        else{
            items = <tr>
                        <td colSpan={6} className='text-center'>No data to display</td>
                    </tr>
        }


        setTableItems(items)
    }

    function editAddress(address_data, address_id, data_index){
        setAddressID(address_id)
        setAddressIndex(data_index)
        setAddressData(address_data)
        setShowModal(1)
    }

    function newAddress(){
        setAddressID('')
        setAddressIndex('')
        setAddressData('')
        setShowModal(1)
    }

    function removeItem(key){
        let items = [...address_list]
        items.splice(key, 1); 

        setAddress(items)
    }
    
    function inputChange(e,) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        setRecordData({ ...record_data, ...new_state });
    }

    function handleAddress(e, index){
        let items = [...address_list]

        let new_item = {
            "id": e.id,
            "vendor_id":  e.reference_id,
            "address_type_id": e.address_type_id,
            "contact_name": e.contact_name,
            "phone_no": e.phone_no,
            "email": e.email,
            "address": e.address,
            "flag": e.flag
        }


        if(index){
            items[index] = new_item
        }
        else{
            items.push(new_item)
        }

        setAddressData(new_item)
        setAddress(items)
    }

    function validateForm(){
        let new_errors = {...errors}
        let variant_errors = 0;

        if(!record_data.vendor_name){
            new_errors['vendor_name'] = ['The vendor name field is required.']
        }
        else{
            delete new_errors['vendor_name'];
        }

        if(!record_data.vendor_type_id){
            new_errors['vendor_type_id'] = ['The type field is required.']
        }
        else{
            delete new_errors['vendor_type_id'];
        }


        setErrors(new_errors);

        return new_errors;
    }

    function submit(){
        // const validate = validateForm();
        // if(Object.keys(validate).length){
        //     Swal.fire({
        //         text: 'Please complete all required fields in the form.',
        //         icon: "error",
        //         confirmButtonText: "OK",
        //     })
        //     return
        // }

        let url = helpers.createUrl(`V1/manage/vendor/create`)
        if(vendor_id){
            url = helpers.createUrl(`V1/manage/vendor/${vendor_id}`)
        }

        let form_data = {...record_data}
        form_data.address = address_list;
        if(record_data.phone_no){
            form_data.phone_no = helpers.removeString(record_data.phone_no)
        }
        
        setLoading(1)
        httpRequest(url, 'POST', {
            postdata: form_data,
        }, true)
            .then((res) => {
                setLoading(0)

                let id = vendor_id;
                if(!id){
                    id = res.data.id
                }

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.replace(`/vendors/${id}/edit`);
                        return;
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                Swal.fire({
                    //title: err.message,
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }
    
    const tabAddressHeaderTemplate = (options) => {
        return (
            <div className="flex align-items-center gap-2 p-3" style={{ cursor: 'pointer' }} onClick={options.onClick}>
                <span className="font-weight-bold white-space-nowrap">Address Book</span>
                {
                    errors.hasOwnProperty('address') && <Badge className='ml-2' value="Error" severity="danger" />
                }
            </div>
        )
    };


    return (
        <>
        <AddressFormModal 
            is_show={show_modal} 
            setShow={setShowModal} 
            handleSave={handleAddress} 
            reference_id={selected_address_id}
            index={selected_address_index}
            address_data={selected_address_data}
            origin="vendor"
        />

        <Layout page_title={page_title} menu="manage-vendors" breadcrumbs={true} parent_link='/vendors/list' parent_text="Manage Vendors">
                <div className="content">
                    <div className="container-fluid pb-5" style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>
                        <form id="pr-form">
                            <div className="row mb-2 d-flex align-items-stretch">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body pt-md-5">
                                            {
                                                vendor_id &&
                                                <div className="row">
                                                    {/* Name */}
                                                    <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                        <label>Vendor No</label>
                                                    </div>
                                                    <div className="col-md-2 form-group">
                                                        <InputText
                                                            id="vendor_id" 
                                                            name="vendor_id" 
                                                            value={vendor_id}
                                                            tagClass="form-control mb-0"
                                                            placeholder="ID"
                                                            onChange={inputChange}
                                                            className='w-100'
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            <div className="row">
                                                {/* Type */}
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Type<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <ButtonGroupSelection
                                                        tagClass="form-control"
                                                        id="vendor_type_id"
                                                        name='vendor_type_id' 
                                                        value={record_data.vendor_type_id}  
                                                        onChange={inputChange}
                                                        onFocus=""
                                                        optionList={store.contact_type}
                                                        optionProps ={{value:'id', label:'label'}}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="vendor_type_id" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* Name */}
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label htmlFor="vendor_name">Vendor Name<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputText
                                                        id="vendor_name" 
                                                        name="vendor_name" 
                                                        value={record_data.vendor_name}
                                                        tagClass="form-control mb-0"
                                                        placeholder="Vendor Name"
                                                        onChange={inputChange}
                                                        autoFocus={1}
                                                        className='w-100'
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="vendor_name" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* Primary Contact Name */}
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label htmlFor="contact_name">Contact Name</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputText
                                                        id="contact_name" 
                                                        name="contact_name" 
                                                        value={record_data.contact_name}
                                                        tagClass="form-control mb-0"
                                                        placeholder="Contact Name"
                                                        onChange={inputChange}
                                                        className='w-100'
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="contact_name" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Address</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputTextArea
                                                        id="vendor_address" 
                                                        name="vendor_address" 
                                                        value={record_data.vendor_address}  
                                                        tagClass="form-control"
                                                        onChange={inputChange}
                                                        rows={2}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="vendor_address" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div> */}
                                            <div className="row">
                                                {/* Email */}
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label htmlFor="email">Email</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputText
                                                        id="email" 
                                                        name="email" 
                                                        value={record_data.email}
                                                        tagClass="form-control mb-0"
                                                        placeholder="Email"
                                                        onChange={inputChange}
                                                        type="email"
                                                        keyfilter="email"
                                                        className='w-100'
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="email" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* Email */}
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Phone No</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputMask 
                                                        id="phone_no" 
                                                        name="phone_no" 
                                                        mask="9999-999-9999" 
                                                        value={record_data.phone_no}
                                                        placeholder="0920-321-5468"
                                                        onChange={inputChange}
                                                        className='w-100'
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="phone_no" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* Notes */}
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label className='mb-0'>Note</label><br/>
                                                    <small>(Option only)</small>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputTextArea
                                                        id="notes" 
                                                        name="notes" 
                                                        value={record_data.notes}  
                                                        tagClass="form-control"
                                                        onChange={inputChange}
                                                        rows={2}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="notes" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="card">
                                <div className="card-body p-0 pt-1">
                                    <TabView panelContainerClassName="p-0">
                                        <TabPanel header="Address Book" contentClassName="p-0" headerTemplate={tabAddressHeaderTemplate}>
                                            <p className="table-responsive mb-1">
                                                    <table className='table mb-0'>
                                                        <thead className='thead-light'>
                                                            <tr>
                                                                <th width={70}>Type</th>
                                                                <th>Address</th>
                                                                <th>Contact Name</th>
                                                                <th>Email</th>
                                                                <th>Phone No</th>
                                                                <th width={120}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {table_items}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan={6} className='text-center'>
                                                                    <center>
                                                                    <RenderErrors 
                                                                        errors={errors} 
                                                                        name="address" 
                                                                        className="text-danger mb-2"
                                                                        style={{fontSize: '.9rem'}}
                                                                    />
                                                                    </center>
                                                                    <button type="button" className="btn btn-outline-primary" onClick={(e) => newAddress(1)}><i className="fas fa-plus-circle mr-2" />New Address</button>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                            </p>
                                        </TabPanel>
                                    </TabView>
                                </div>
                            </div>

                            {/* <div id="address-item-container mt-5" className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header"><h5 className='mb-0'>Address Book</h5></div>
                                        <div className="card-body p-0 table-responsive">
                                            <table className='table mb-0'>
                                                <thead className='thead-light'>
                                                    <tr>
                                                        <th width={70}>Type</th>
                                                        <th>Address</th>
                                                        <th>Contact Name</th>
                                                        <th>Email</th>
                                                        <th>Phone No</th>
                                                        <th width={120}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {table_items}
                                                    <tr className='bg-light'>
                                                        <td colSpan={6} className='text-center'>
                                                            <button type="button" className="btn btn-outline-primary" onClick={(e) => newAddress(1)}><i className="fas fa-plus-circle mr-2" />New</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <center>
                                            <RenderErrors 
                                                errors={errors} 
                                                name="items" 
                                                className="text-danger mb-2"
                                                style={{fontSize: '.9rem'}}
                                            />
                                            </center>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className='text-right mt-3'>   
                            <button type='button' className='btn btn-success mr-3 ' onClick={(e) => submit(1)}>Save</button>  
                                <Link className='btn btn-outline-dark' to="/vendors/list">Cancel</Link>    
                            </div>
                        </form>
                    </div>
                </div>
        </Layout>
        </>
    )
}